import * as React from 'react';
import Typography from '@mui/material/Typography';
import { getExcerciseChoiceConfig, newLineParser } from "../utils";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import { getExcerciseText } from "../utils";
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import { Choices } from '../enums';
import { CardActionArea } from '@mui/material';
import { Box } from '@mui/material';
import Chip from '@mui/material/Chip';
import TranscriptionVideo from '../components/TranscriptionVideo';


export default function ExcerciseChoicePage({ pageId, excerciseId, setChoice }) {


    const questionTextA = getExcerciseChoiceConfig(pageId, excerciseId, Choices.A)['vraag'];
    const questionTextB = getExcerciseChoiceConfig(pageId, excerciseId, Choices.B)['vraag'];

    // about 75 character per line
    const qTextLength = Math.max(questionTextA.length, questionTextB.length);
    let minCardHeight = '80px';
    if (qTextLength > 150) {
        minCardHeight = '90px';
    }
    if (qTextLength > 225) {
        minCardHeight = '115px';
    }


    const ChoiceButton = ({ choice }) => (
        <Box m="auto">
            <Button variant="outlined" >
                Keuze {choice}
            </Button>
        </Box>
    );



    const showIntroText = getExcerciseText(pageId, excerciseId, "inleiding") ? true: false;
    const IntroText = () => (
        <div>
            <Typography variant="h5" gutterBottom>
                Inleiding
            </Typography>

            <Typography variant="body2" gutterBottom>
                {getExcerciseText(pageId, excerciseId, "inleiding")}
            </Typography>
            <br />
        </div>        
    ); 
    
    let transVideoSrc = getExcerciseText(pageId, excerciseId, "inleiding_film");

    // When there is no video source show the choice text, otherwise the choice text is shown at the end of the video 
    const [choiceVisible, setChoiceVisible] = React.useState(transVideoSrc === null || transVideoSrc.length === 0 ? true: false);
    const showChoiceText = () => {
        setChoiceVisible(true);
    }
    
    let ChoiceText = () => (
            <div>
            <Typography variant="h5" gutterBottom>
                Vraag {excerciseId + 1}
            </Typography>

            <Typography variant="body2" gutterBottom>
                {newLineParser(getExcerciseText(pageId, excerciseId, "vraag_text"))}
            </Typography>

            <Grid
                container
                spacing={3}
                justifyContent="center"
                alignItems="stretch"
                my={2}
            >
                <Grid key={"keuze_a"} item xs={12} sm={6}>
                    <Card>
                        <CardActionArea component="a" onClick={() => setChoice(Choices.A)}>
                            <CardContent style={{ textAlignVertical: "center", textAlign: "center", minHeight: minCardHeight }}>
                                <Typography variant="body2">
                                    {questionTextA}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <ChoiceButton choice={Choices.A} />
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid key={"keuze_b"} item xs={12} sm={6}>
                    <Card >
                        <CardActionArea component="a" onClick={() => setChoice(Choices.B)}>
                            <CardContent style={{ textAlignVertical: "center", textAlign: "center", minHeight: minCardHeight }}>
                                <Typography variant="body2">
                                    {questionTextB}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <ChoiceButton choice={Choices.B} />
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            </div>
    );

    return (
        <React.Fragment>

            {showIntroText ? <IntroText /> : null}

            <TranscriptionVideo src={transVideoSrc} transcription={getExcerciseText(pageId, excerciseId, "inleiding_film_transcriptie")} onEnded={showChoiceText}/>

            {choiceVisible ? <ChoiceText /> : null}

        </React.Fragment>
    );
}
